

import React, { memo } from 'react';
import { FormModal, Text, useApi } from '../../../../ui-kit';
import { ABOUT_ADDON_OPTIONS } from '../../../../common/constants/aboutAddonOptions';

import '../styles/_about-addon-modal.scss';








const AboutAddonModal = ({
  addonType,
  visible,
  onClose,
  getExplanationVideoUrl
}) => {
  const { data } = useApi({
    fn: getExplanationVideoUrl,
    dataBasePath: 'getS3SignedUrl'
  }, [getExplanationVideoUrl]);

  return (
    <div className="about-addon-modal">
      <FormModal
        className="about-addon-modal__form"
        visible={visible}
        onClose={onClose}
        title={ABOUT_ADDON_OPTIONS[addonType].MODAL.TITLE}
        hideFooter>

        <div className="about-addon-modal__content">
          <Text className="about-addon-modal__description">
            {ABOUT_ADDON_OPTIONS[addonType].MODAL.DESCRIPTION}
          </Text>

          {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
          <video className="about-addon-modal__video" src={data} controls />
        </div>
      </FormModal>
    </div>);

};

export default memo(AboutAddonModal);